import * as React from "react";

function Error(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 18 18" fill="none" {...props}>
      <path
        d="M8.118 11.875c0-.46.374-.833.834-.833h.007a.833.833 0 110 1.666h-.007a.833.833 0 01-.834-.833zM8.333 9.375a.625.625 0 001.25 0V6.042a.625.625 0 10-1.25 0v3.333z"
        fill="red"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.593.22a4.33 4.33 0 012.73 0c.884.294 1.577.99 2.274 1.967.695.974 1.462 2.331 2.451 4.082l.039.068c.99 1.751 1.757 3.109 2.235 4.21.48 1.107.72 2.062.529 2.98a4.507 4.507 0 01-1.357 2.4c-.689.633-1.627.9-2.808 1.029-1.174.127-2.71.127-4.687.127h-.081c-1.977 0-3.513 0-4.688-.127-1.18-.129-2.119-.396-2.807-1.03a4.507 4.507 0 01-1.357-2.4c-.191-.917.048-1.872.529-2.979.478-1.101 1.245-2.459 2.235-4.21l.038-.068c.99-1.75 1.757-3.109 2.452-4.082C6.016 1.21 6.71.514 7.593.22zM9.93 1.408a3.08 3.08 0 00-1.943 0c-.497.165-.996.588-1.65 1.505-.651.914-1.387 2.214-2.4 4.006-1.012 1.792-1.747 3.093-2.196 4.127-.45 1.036-.562 1.695-.451 2.227.14.671.483 1.278.979 1.734.39.359.996.587 2.096.707s2.567.12 4.593.12c2.027 0 3.495 0 4.593-.12 1.1-.12 1.707-.348 2.097-.707.496-.456.84-1.063.98-1.734.11-.532-.003-1.191-.453-2.227-.449-1.034-1.183-2.335-2.196-4.127-1.012-1.792-1.748-3.092-2.4-4.006-.654-.917-1.153-1.34-1.65-1.505z"
        fill="red"
      />
    </svg>
  );
}

export default Error;
